export var GET_ALL_UTILITY_DATA = "GET_ALL_UTILITY_DATA";
export var CANCEL_GET_ALL_UTILITY_DATA = "CANCEL_GET_ALL_UTILITY_DATA";
export var GET_LOCALIZATION_INFO = "GET_LOCALIZATION_INFO";
export var CANCEL_GET_LOCALIZATION_INFO = "CANCEL_GET_LOCALIZATION_INFO";
export var UPDATE_LOCALIZATION_INFO = "UPDATE_LOCALIZATION_INFO";
export var GET_TIMEZONES = "GET_TIMEZONES";
export var CANCEL_GET_TIMEZONES = "CANCEL_GET_TIMEZONES";
export var UPDATE_TIMEZONES = "UPDATE_TIMEZONES";
export var UPDATE_CONSTANTS = "UPDATE_CONSTANTS";
export var UPDATE_UTILITIES_STATUS = "UPDATE_UTILITIES_STATUS";
export var UPDATE_KIOSK = "UPDATE_KIOSK";
